export default function MobileToggleBtn({ toggleSidebar, isOpen, className }) {
  return (
    <div
      onClick={toggleSidebar}
      className={`sm:hidden menu ${className} flex ${isOpen && "active"}`}
    >
      <div className="flex flex-col gap-[4px] w-[30px] justify-between cursor-pointer">
        <div className="flex  bg-[#000000] h-[3px] w-[25px] "></div>
        <div className="flex  bg-[#000000] h-[3px] w-[25px] "></div>
        <div className="flex  bg-[#000000] h-[3px] w-[25px] "></div>
      </div>
    </div>
  );
}
